import { Component, Injectable, Input } from '@angular/core';
// TODO didn't we get a piece of code from iTransition we can use for the ToastController?

@Injectable({ providedIn: 'root' })
@Component({
    selector: 'app-modal-controller',
    templateUrl: './ModalController.html',
    styleUrls: ['./ModalController.css'],
    standalone: false
})
export class ModalController {

  public title: string;
  public description: string;
  public spinButtonText: string;
  public spinnedTitle: string;
  public spinnedDescription: string;
  public spinnedButtonText: string;
  public declineButtonText: string;
  public wheelCenterImage: string;
  public wheelOptions: any;
  public pointerAngle: number = 90;
  public closeAfterSpinTime: number = 0;
  public spinningState: string = 'not-spinning';

  private spinnerKeyFrames: string = '';

  private rotationStartDegrees: string;
  private rotationDegrees: string = '4215';


  create(UpsellOfferSpinnerComponent: any, spinnerData: any, arg2: { cssClass: string; }) {
    console.log('create modal');
    if((document.querySelector('.showRouletteWheel') as HTMLButtonElement)) {
      (document.querySelector('.showRouletteWheel') as HTMLButtonElement).click();
      document.body.classList.add('noscroll');
    }
    return new Promise<ModalController>((resolve, reject) => {
      resolve(this);
    });
  }

  setState(state: string) { 
    return new Promise<void>((resolve, reject) => {
      resolve();
    });
  }
  constructor() {

    let spinnerData = {
      title: 'Spin the wheel',
      description: 'Spin the wheel to see if you can win a discount on your order today!',
      spinButtonText: 'Spin the wheel',
      spinnedTitle: 'You won!',
      spinnedDescription: 'You won a discount on your order today!',
      spinnedButtonText: 'Claim your discount',
      declineButtonText: 'No thanks, I don\'t want to spin the wheel',
      wheelCenterImage: '', 
      wheelOptions: [
        {
          title: '10% off',
          description: '10% off your order today',
          actualOffer: true,
        },
        {
          title: '20% off',
          description: '20% off your order today',
          actualOffer: false,
        },
        {
          title: '30% off',
          description: '30% off your order today',
          actualOffer: false,
        },
        {
          title: '40% off',
          description: '40% off your order today',
          actualOffer: false,
        },
        {
          title: '50% off',
          description: '50% off your order today',
          actualOffer: false,
        },
        {
          title: '60% off',
          description: '60% off your order today',
          actualOffer: false,
        },
        {
          title: '70% off',
          description: '70% off your order today',
          actualOffer: false,
        },
        {
          title: '80% off',
          description: '80% off your order today',
          actualOffer: false,
        },
        {
          title: '90% off',
          description: '90% off your order today',
          actualOffer: false,
        },
        {
          title: '100% off',
          description: '100% off your order today',
          actualOffer: false,
        },
      ],
      pointerAngle: 90,
      closeAfterSpinTime: 6,
    }

    if ( spinnerData ) {
      this.title = spinnerData.title;
      this.description = spinnerData.description;
      this.spinButtonText = spinnerData.spinButtonText;
      this.spinnedTitle = spinnerData.spinnedTitle;
      this.spinnedDescription = spinnerData.spinnedDescription;
      this.spinnedButtonText = spinnerData.spinnedButtonText;
      this.declineButtonText = spinnerData.declineButtonText;
      this.wheelCenterImage = spinnerData.wheelCenterImage;
      this.wheelOptions = spinnerData.wheelOptions || [];
      this.pointerAngle = spinnerData.pointerAngle || 90;
      this.closeAfterSpinTime = spinnerData.closeAfterSpinTime || 6;


      this.rotationStartDegrees = (
        Math.floor( Math.random() * spinnerData.wheelOptions.length ) * ( 360 / spinnerData.wheelOptions.length )
      ).toString() || '120';

      const rightAnswerIndex = spinnerData.wheelOptions.findIndex( option => {
        return option.actualOffer === true;
      } );

      const offerAngle = (
        3600 // 10 spins
        + ( ( 360 / spinnerData.wheelOptions.length ) / 2 ) // Add half the angle of one option.
        - this.pointerAngle // Subtract the angle at which the pointer is at.
        + ( rightAnswerIndex * ( 360 / spinnerData.wheelOptions.length ) ) // Increament the total by the full angle for the number of options
      ).toString();

      this.rotationDegrees = offerAngle || '3495';
      // console.log( 'spinner - right answer Index: ', rightAnswerIndex );
      // console.log( 'spinner - rotationDegrees: ', this.rotationDegrees, ( this.rotationDegrees - 3600 ) );

    }

    this.spinnerKeyFrames = `
      .main-page-element {
        filter: blur(10px);
        filter:progid:DXImageTransform.Microsoft.Blur(pixelradius='10', shadowopacity='0.0');
      }

      upsell-offer-spinner .spinnerWheelMotor {
        transform: rotate(${ this.rotationStartDegrees }deg);
      }

      upsell-offer-spinner .spinnerWheelMotor.spinned {
        transform: rotate(${ this.rotationDegrees }deg)
      }

      upsell-offer-spinner .spinnerWheelMotor.spinning {
        transform: rotate(${ this.rotationDegrees }deg)
      }

      @keyframes spinTheWheel {
        0% {
          transform: rotate(${ this.rotationStartDegrees }deg)
        }
        100% {
          transform: rotate(${ this.rotationDegrees }deg)
        }
      }
    `;

    this.setSpinnerStyles();
  }
 
  setSpinnerStyles() {
    const body = document.getElementsByTagName( 'body' )[ 0 ];
    const style = document.createElement( 'style' );
    style.type = 'text/css';
    style.setAttribute( 'id', 'spinner-specific-styles' );
    style.appendChild( document.createTextNode( this.spinnerKeyFrames ) );
    body.appendChild( style );
  }
  dialogShowModal(dialog:any) {
    console.log('dialogShowModal');
    (dialog as any).showModal();
  }

  dialogHideModal(dialog:any) {
    console.log('dialogHideModal');
    dialog.hide();
  }
}
